import ConfigurationCommentsModalContent from './ConfigurationCommentsModalContent/ConfigurationCommentsModalContent';
import { TConfigData } from '../../../types/product.configuration.types';
import { capitalize } from 'utils/namingConventionsManagement';
import NudosGenericModal from '../NudosGenericModal';
import NudosModalContent from '../NudosModalContent/NudosModalContent';

import './ConfigurationCommentsModal.scss';

const ConfigurationCommentsModal = ({
  closeModalCallback,
  comments,
  configData,
  configClassId,
  isAdditionalSettingsInOrders
}: {
  closeModalCallback: () => void;
  comments: string;
  configData?: TConfigData[] | null;
  configClassId?: number | null;
  isAdditionalSettingsInOrders?: boolean;
}) => {
  const subTitleText = 'Consulta los detalles de la configuración solicitada para esta herramienta.';

  return (
    <NudosGenericModal
      customClassName="configurationCommentsModal"
      closeModalCallback={closeModalCallback}
      clickOutsideCallback={closeModalCallback}
      closesOnClickOutside={true}
      modalContent={
        <NudosModalContent
          componentSize="medium"
          modalContentTitle={capitalize('Configuración')}
          modalContentSubtitle={subTitleText}
          toCloseModal={closeModalCallback}
          customHeaderClass="configurationCommentsModalHeader"
          CustomModalComponent={
            <ConfigurationCommentsModalContent
              comments={comments}
              configData={configData}
              configClassId={configClassId}
              isAdditionalSettingsInOrders={isAdditionalSettingsInOrders}
              closeModalCallback={closeModalCallback}
            />
          }
        />
      }
    />
  );
};

export default ConfigurationCommentsModal;
